import userQuestions from "../../images/hireDeveloper/user-questions.svg";
import customDeveloper from "../../images/hireDeveloper/custom-developer.svg";
import android from "../../images/home/technology/android.svg";
import angular from "../../images/home/technology/angular.svg";
import apple from "../../images/home/technology/apple.svg";
import dotnet from "../../images/home/technology/dotnet.svg";
import flutter from "../../images/home/technology/flutter.svg";
import nodejs from "../../images/home/technology/nodejs.svg";
import php from "../../images/home/technology/php.svg";
import react from "../../images/home/technology/react.svg";
import xamarin from "../../images/home/technology/xamarin.svg";
import vuejs from "../../images/home/technology/vuejs.svg";

export const getSkillData = [
  {
    id: 0,
    images: android,
    name: "Android Developer",
  },
  {
    id: 1,
    images: angular,
    name: "Angular Developer",
  },
  {
    id: 2,
    images: apple,
    name: "iOS Developer",
  },
  {
    id: 3,
    images: dotnet,
    name: "Asp.Net Developer",
  },
  {
    id: 4,
    images: flutter,
    name: "Flutter Developer",
  },
  {
    id: 5,
    images: nodejs,
    name: "Node.js Developer",
  },
  {
    id: 6,
    images: php,
    name: "Laravel Developer",
  },
  {
    id: 7,
    images: react,
    name: "React.js Developer",
  },
  {
    id: 8,
    images: xamarin,
    name: "Xamarin Developer",
  },
  {
    id: 9,
    images: vuejs,
    name: "Vue.js Developer",
  },
  {
    id: 10,
    images: customDeveloper,
    name: "Custom Developer",
  },
];

export const userexperience = [
  { id: 0, value: "less3", label: "Less Than 3 Years" },
  { id: 1, value: "3to5", label: "3 To 5 Years" },
  { id: 2, value: "more5", label: "More Than 5 Years" },
];

export const internationalclients = [
  { id: 0, value: "yes", label: "Yes" },
  { id: 1, value: "no", label: "Not Yet" },
];

export const compensationData = [
  "< 5 LPA",
  "5-7 LPA",
  "7-10 LPA",
  "10-15 LPA",
  "15-20 LPA",
  "> 20+ LPA",
];
